<template>
    <div>
        <a-button class="top_btn" type="primary"  @click="()=>{  visible = true; title='添加标准值' }" v-has="'btn_add'"  >
            添加
        </a-button>
        <a-table :columns="columns" :data-source="data" :loading="loading"  rowKey="id"  :pagination="false" >

            <span slot="start_time" slot-scope="text, record">
        {{record.start_time}}-{{record.end_time}}
      </span>
            <span slot="status" slot-scope="text, record">
         <a-switch   @click="onChange(record)"
                   :checked="text==1?true:false" :disabled="!$_has('btn_status')"/>
      </span>


            <span slot="action" slot-scope="text, record">
                <i v-if="$_hasAll(['btn_edit','btn_delete'])" style="color:#838383">暂无操作权限</i>
        <a  @click="(record)=>{visible = true; title='修改标准值'; editId=text.id ; }" v-has="'btn_edit'">编辑<a-divider type="vertical"/></a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm([record.id])"
                  @cancel="()=>{}"
          >
   <a v-has="'btn_delete'">删除</a>
  </a-popconfirm>
      </span>
        </a-table>
        <UvForm :visible="visible" :title="title" :editId="editId"
                  @changVisible=" () => { this.visible = false;this.editId='';  this.getList()}  "/>
    </div>
</template>

<script>
    import API from "../api";
import UvForm from "./uvForm"
    import {changStatus, removeById,orderList} from "../../../../utils/utils"
    const columns = [
        {
            title: "运营时间",
            dataIndex: "start_time",
            ellipsis: true,
            key: "start_time",
            scopedSlots: {customRender: "start_time"}
        },

        {
            title: "PV标准值",
            dataIndex: "uv",
            ellipsis: true,
            key: "uv",
        },
        {
            title: "状态",
            key: "status",
            width: "150px",
            dataIndex: "status",
            scopedSlots: {customRender: "status"}
        },
        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "adetectUvSuggest",
        data() {
            return {
                visibleImg: false,
                tableImg: "",
                data: [],
                columns,
                selectedRowKeys: [], // Check here to configure the default column
                loading: true,
                visible: false,
                title: "",
                editId: null
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/WebsiteDetection/UVstandard"; //设置左侧导航2-2 active
        },
        components:{UvForm},
        mounted() {
            this.getList()
        },
        methods: {
            confirm(id) {
                removeById(API.service.DELE,id).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            onChange(row) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                changStatus(API.service.CHANG_STATUS, [Json]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            add(id) {
                if (id == '') {
                    this.$router.push('/WebsiteDetection/AddVideoSuggestions')
                } else {
                    this.$router.push(`/WebsiteDetection/EditVideoSuggestions?id=${id}`)
                }

            },
            getList(page) {
                API.service.GET_LIST({page: page || 1, ...this.seach}).then(res => {
                    this.data = res.data.data
                    this.loading = false
                })
            },
        }
    }
</script>

<style scoped>
</style>
